import { useCallback } from "react";
import { Link } from "react-router-dom";

import bgImage from "~/assets/img/loginBackground.png";
import { PageContainer } from "~/layout/personalTrainer/PageContainer";
import { authenticatePersonalTrainer } from "~/modules/authentication/services";
import {
	personalTrainerRecoverPasswordRoute,
	signUpRoute,
} from "~/routes/routes";
import { app_version } from "~/utils/version";

import { LoginForm } from "../../../forms/PersonalTrainer/Login";
import type { PersonalTrainerSignInDTO } from "../../../modules/authentication/schema";

export const PersonalTrainerLogin: React.FC = () => {
	const handleSubmitForm = useCallback(
		async (payload: PersonalTrainerSignInDTO) => {
			await authenticatePersonalTrainer(payload);
		},
		[],
	);

	return (
		<PageContainer>
			<div
				className="flex flex-1 bg-no-repeat bg-left-top bg-cover"
				style={{
					backgroundImage: `url(${bgImage})`,
					minHeight: window.innerHeight,
				}}
			>
				<div className="flex flex-col items-center w-full max-w-2xl bg-white ml-auto px-6">
					<div className="flex flex-col flex-1 w-full items-start justify-center gap-3">
						<h1 className="text-4xl font-semibold">Bem Vindo,</h1>
						<p className="text-xl">Para acessar o GPA, faça o login abaixo.</p>
						<div className="flex flex-col gap-4 w-full">
							<LoginForm onSubmit={handleSubmitForm} />
							<div className="flex justify-between">
								<Link to={signUpRoute} className="text-gpa-blue-500">
									Realizar cadastro
								</Link>
								<Link
									target="_blank"
									to={personalTrainerRecoverPasswordRoute}
									className="ml-auto text-gpa-blue-500"
								>
									Esqueci minha senha
								</Link>
							</div>
						</div>
					</div>
					<p className="self-end pb-1 text-black">{app_version}</p>
				</div>
			</div>
		</PageContainer>
	);
};
